// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sharePlaylistPopupContent_root__3L_SD {\n  margin-bottom: 20px; }\n  .sharePlaylistPopupContent_root__3L_SD .sharePlaylistPopupContent_title__194Dd {\n    margin-bottom: 20px;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 22px;\n    color: #333333;\n    margin-top: 10px;\n    text-align: center;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n", ""]);
// Exports
exports.locals = {
	"root": "sharePlaylistPopupContent_root__3L_SD",
	"title": "sharePlaylistPopupContent_title__194Dd"
};
module.exports = exports;
